import { createBrowserRouter } from "react-router";
import HomeView from "../../view/home-view";

const router = createBrowserRouter([
  {path: "/", element: <HomeView />},
])

export default router;